export const companyTypes = [
  { value: 'A', name: 'Association/Estate/Trust' },
  { value: 'G', name: 'Government (Federal/State/Local)' },
  { value: 'S', name: 'Individual/Sole Proprietor' },
  { value: 'F', name: 'Financial Institution' },
  { value: 'L', name: 'LLC (Limited-Liability Corporation)' },
  { value: 'E', name: 'Tax-Exempt Organization (501C)' },
  { value: 'P', name: 'Partnership' },
  { value: 'V', name: 'Private Corporation' },
  { value: 'B', name: 'Public Corporation' },
  { value: 'R', name: 'SEC-Registered Entity' }
];
